import apiService from './api';

export interface Country {
  id: number;
  name: string;
  code: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface City {
  id: number;
  name: string;
  countryId: number;
  countryName?: string;
  latitude?: number;
  longitude?: number;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export class LocationService {
  // Countries
  async getAllCountries(): Promise<Country[]> {
    return apiService.get<Country[]>('/api/locations/countries');
  }

  async getCountryById(id: number): Promise<Country> {
    return apiService.get<Country>(`/api/locations/countries/${id}`);
  }

  async createCountry(countryData: Partial<Country>): Promise<Country> {
    return apiService.post<Country>('/api/locations/countries', countryData);
  }

  async updateCountry(id: number, countryData: Partial<Country>): Promise<Country> {
    return apiService.put<Country>(`/api/locations/countries/${id}`, countryData);
  }

  async deleteCountry(id: number): Promise<void> {
    await apiService.delete(`/api/locations/countries/${id}`);
  }

  // Cities
  async getAllCities(): Promise<City[]> {
    return apiService.get<City[]>('/api/locations/cities');
  }

  async getCitiesByCountry(countryId: number): Promise<City[]> {
    return apiService.get<City[]>(`/api/locations/countries/${countryId}/cities`);
  }

  async getCitiesByCountryCode(countryCode: string): Promise<City[]> {
    return apiService.get<City[]>(`/api/locations/countries/code/${countryCode}/cities`);
  }

  async getCityById(id: number): Promise<City> {
    return apiService.get<City>(`/api/locations/cities/${id}`);
  }

  async createCity(cityData: Partial<City>): Promise<City> {
    return apiService.post<City>('/api/locations/cities', cityData);
  }

  async updateCity(id: number, cityData: Partial<City>): Promise<City> {
    return apiService.put<City>(`/api/locations/cities/${id}`, cityData);
  }

  async deleteCity(id: number): Promise<void> {
    await apiService.delete(`/api/locations/cities/${id}`);
  }
}

export const locationService = new LocationService();
export default locationService;
